export const MAX_ATTACHMENT_SIZE = 10 * 1024 * 1024;
